// Script - event binding for findify-tabs.liquid

const initFindifyTabsEvents = () => {
  const selectors = {
    tabContent: ".findify-tab-content",
    tab: ".findify-tab",
    id: (tab_id) => `${tab_id}-content`,
  };

  const getContentData = async (target) => {
    return await findify.contents.api({ [target]: findify.grid.liquid?.contents[target] });
  }

  const renderContents = async (target) => {
    const contentData = await getContentData(target);
    // contents.api returns the state of every tab loaded so far; render only this
    // one, or switching tabs re-appends the previously opened tabs' items.
    findify.grid.renderContents({ [target]: contentData[target] }, false);
    return contentData[target].meta.total;
  }

  // Findify only sends tab ids and titles, so fetch each tab's total up front
  // (limit 1, nothing rendered). Cached per query since the grid re-renders
  // this section on every filter or sort change.
  const getContentTotals = async () => {
    const query = findify.utils.getQuery();
    if (findify.contents._tabTotals?.query === query) {
      return findify.contents._tabTotals.totals;
    }

    const totals = Object.fromEntries(
      await Promise.all(
        Object.keys(findify.grid.liquid?.contents).map(async (content_id) => {
          const response = await findify.core.client.send({
            type: "content",
            params: { q: query, type: [content_id], limit: 1 },
          });
          return [content_id, response?.meta?.total ?? 0];
        })
      )
    );
    findify.contents._tabTotals = { query, totals };
    return totals;
  };

  const renderTabCounts = async () => {
    const totals = await getContentTotals();
    Object.keys(totals).forEach((content_id) => {
      const contentTabEl = document.querySelector(`button[target=${content_id}]`);
      if (!contentTabEl) return;
      contentTabEl.querySelector("span").innerText = totals[content_id];
      // Inline style: .findify-tab's display: flex would override the hidden attribute
      contentTabEl.style.display = totals[content_id] === 0 ? "none" : "";
    });
  };

  const onTabClick = (event, tab_id) => {
    let i, tabContent, tabs;
    tabContent = document.querySelectorAll(selectors.tabContent);
    for (i = 0; i < tabContent.length; i++) {
      tabContent[i].style.display = "none";
    }
    tabs = document.querySelectorAll(selectors.tab);
    for (i = 0; i < tabs.length; i++) {
      tabs[i].className = tabs[i].className.replace(" findify-active", "");
    }
    document.getElementById(selectors.id(tab_id)).style.display = "block";
    event.currentTarget.className += " findify-active";
  };

  const init = () => {
    if (Object.keys(findify.grid.liquid?.contents).length > 0) {
      document.querySelectorAll(".findify-tab").forEach((element) => {
        element.addEventListener("click", (event) => {
          onTabClick(event, element.getAttribute("target")
          )
        }
        );
      });

      Object.keys(findify.grid.liquid?.contents).forEach(content_id => {
        const contentTabEl = document.querySelector(`button[target=${content_id}]`)
        initOneTimeClick(contentTabEl)
      })

      renderTabCounts().catch((error) => console.error("Findify tab counts", error));
    }
  };

  const clickEvent = async (ev) => {
    // Remove before awaiting so a second click while loading can't append twice
    const tabEl = ev.currentTarget
    tabEl.removeEventListener('click', clickEvent)
    const total = await renderContents(tabEl.getAttribute('target'))
    tabEl.querySelector('span').innerText = total
    initFindifyContentEvents()
  }

  const initOneTimeClick = (contentTabEl) => {
    if(contentTabEl) contentTabEl.addEventListener('click', clickEvent);
  }

  init();
};
